// Catalog menu
(function() {
	var catalogMenu = '#catalog-menu';
	
	$(catalogMenu).on('click', function () {
		$(this).toggleClass('catalog-menu--open');
	});

	$(document).on('click', function (event) {
		if (!$(event.target).parents(catalogMenu).length) {
			if ($(catalogMenu).hasClass('catalog-menu--open'))
				$(catalogMenu).removeClass('catalog-menu--open');
		}
	});

})();


// WEBPACK FOOTER //
// G:/RABOTA/satpharma/dev/source/modules/catalog-menu/catalog-menu.js